/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { Behavior } from 'backbone.marionette';

import callByNeed from '../util/callByNeed';

const ToggleBehavoir = Behavior.extend({
  onRender() {
    const toggles = callByNeed(this.options.toggles) || [];
    toggles.forEach((toggle) => {
      this.$(toggle.group).on('change', () => {
        this.handleTargetDisplay(toggle);
      });
      this.handleTargetDisplay(toggle);
    });
  },

  handleTargetDisplay(toggle) {
    let currentValue;
    if (this.$(toggle.group).prop('tagName') === 'SELECT') {
      currentValue = this.$(`${toggle.group} option:selected`).val();
    } else {
      currentValue = this.$(`${toggle.group}:checked`).val();
    }
    let showValue;
    if (_.isArray(toggle.valuesToShow)) {
      showValue = toggle.valuesToShow.find((val) => val === currentValue);
    } else {
      showValue = toggle.valuesToShow === currentValue;
    }
    if (showValue) {
      this.$(toggle.target).show();
      this.$(toggle.target).removeAttr('disabled');
    } else {
      this.$(toggle.target).hide();
      this.$(toggle.target).attr('disabled', '');
    }
  },
});

export default ToggleBehavoir;
